package com.routexk.quiz.data.http

import com.routexk.quiz.core.config.AppConfig
import com.routexk.quiz.core.logger.getLogger
import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.plugins.logging.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

object HttpClientFactory {
    private val logger = getLogger<HttpClientFactory>()

    fun createDefault(): HttpClient {
        return HttpClient(Js) {

            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                    encodeDefaults = true
                    prettyPrint = AppConfig.environment == com.routexk.quiz.core.config.Environment.DEVELOPMENT
                })
            }

            if (AppConfig.environment == com.routexk.quiz.core.config.Environment.DEVELOPMENT) {
                install(Logging) {
                    level = LogLevel.ALL
                    logger = object : io.ktor.client.plugins.logging.Logger {
                        override fun log(message: String) {
                            this@HttpClientFactory.logger.debug(message)
                        }
                    }
                }
            }

            expectSuccess = false
        }
    }

    fun createAuthenticated(token: String): HttpClient {
        return HttpClient(Js) {
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                    encodeDefaults = true
                })
            }

            if (AppConfig.environment == com.routexk.quiz.core.config.Environment.DEVELOPMENT) {
                install(Logging) {
                    level = LogLevel.ALL
                    logger = object : io.ktor.client.plugins.logging.Logger {
                        override fun log(message: String) {
                            this@HttpClientFactory.logger.debug(message)
                        }
                    }
                }
            }

            defaultRequest {
                header("Content-Type", "application/json")
                header("Accept", "application/json")
                header("Authorization", "Bearer $token")
            }

            expectSuccess = false
        }
    }
}

fun HttpRequestBuilder.addDefaultHeaders() {
    header("Content-Type", "application/json")
    header("Accept", "application/json")
}

fun HttpRequestBuilder.addAuthHeader(token: String) {
    header("Authorization", "Bearer $token")
}

fun HttpRequestBuilder.setBaseUrl(baseUrl: String) {
    val currentUrl = url.buildString()
    if (!currentUrl.startsWith(baseUrl)) {
        url(baseUrl)
    }
}
